import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { MailCheck } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-5rem)] flex items-center justify-center bg-[#F8FAFC] py-16" data-testid="forgot-password-page">
      <div className="w-full max-w-md ae-card p-8">
        <div className="ae-overline mb-2">Account recovery</div>
        <h1 className="font-heading text-3xl font-medium text-[#0F2A4A] mb-2">Forgot password?</h1>
        {sent ? (
          <div className="mt-6 text-center" data-testid="forgot-success">
            <MailCheck className="w-12 h-12 text-emerald-500 mx-auto mb-3" />
            <p className="text-sm text-slate-600">If an account exists for <b>{email}</b>, a secure reset link has been sent. It expires in 60 minutes and works once.</p>
            <p className="text-xs text-slate-400 mt-3">Didn't get it? Ask your administrator to generate a link from the dashboard.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-4">
            <p className="text-sm text-slate-600">Enter your account email and we'll send you a link to set a new password.</p>
            <input required type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)}
              data-testid="forgot-email" className="w-full rounded-xl border border-slate-200 bg-slate-50 focus:bg-white focus:border-[#C5A059] outline-none px-4 py-3 text-sm" />
            <button disabled={loading} className="ae-btn-primary w-full" data-testid="forgot-submit">{loading ? "Sending…" : "Send Reset Link"}</button>
          </form>
        )}
        <div className="mt-6 text-center text-sm"><Link to="/login" className="text-[#C5A059] font-medium" data-testid="forgot-back-login">Back to sign in</Link></div>
      </div>
    </div>
  );
}
